export default __webpack_public_path__ + "static/media/finance-image.8a1c4179.svg";